{
  "common.close": "మూసివేయి",
  "common.athleteFallback": "అథ్లెట్ {id}",
  "splash.title": "{app} — కార్యకలాపాల యానిమేటెడ్ దృశ్యం",
  "splash.tagline": "మీ&nbsp;Strava డేటా కోసం కదిలే మ్యాప్",
  "splash.demo": "డెమో",
  "tab.query.title": "{name} గారి మ్యాప్",
  "tab.query.heading": "కార్యకలాపాలను వెతకండి:",
  "tab.query.optDays": "ఇటీవలి రోజులు",
  "tab.query.optActivities": "ఇటీవలి కార్యకలాపాలు",
  "tab.query.optIds": "కార్యకలాప IDలు",
  "tab.query.optDates": "తేదీ పరిధి",
  "tab.query.idsPlaceholder": "కార్యకలాప IDలను ఇక్కడ నమోదు చేయండి",
  "tab.query.after": "తర్వాత:",
  "tab.query.before": "ముందు:",
  "tab.query.autozoom": "దిగుమతి తర్వాత ఫలితాలకు ఆటోమేటిక్‌గా జూమ్ <i class=\"hf hf-bullseye\"></i> చేయి",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> వెతుకు",
  "tab.query.createAccount": "ఖాతా సృష్టించండి మరియు/లేదా లాగిన్ అవ్వండి.",
  "tab.query.sports": "క్రీడలు:",
  "tab.query.allSports": "అన్ని క్రీడలు",
  "tab.query.sportsExcept": "ఇవి తప్ప అన్నీ",
  "tab.query.sportsNone": "ఏదీ కాదు",
  "tab.query.loadingSports": "క్రీడలు లోడ్ అవుతున్నాయి…",
  "tab.query.sportsFailed": "ఈ మ్యాప్ క్రీడలను లోడ్ చేయలేకపోయాం",
  "tab.query.noSports": "ఇంకా కార్యకలాపాలు లేవు",
  "tab.activities.title": "చూపిన కార్యకలాపాలు",
  "tab.activities.clearSelection": "ఎంపికను తొలగించు",
  "tab.activities.renderSelected": "ఎంచుకున్నవి చూపించు",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> ఎంపికకు జూమ్ చేయి",
  "tab.controls.title": "లేయర్ సెట్టింగ్‌లు",
  "tab.controls.timescale": "కాలమానం <i>&tau;</i>",
  "tab.controls.timescaleHint": "ప్లేబ్యాక్ వేగం",
  "tab.controls.period": "ఆవర్తనం <i>T</i>",
  "tab.controls.periodHint": "కార్యకలాపం ~ నమూనా",
  "tab.controls.dotSize": "చుక్క పరిమాణం",
  "tab.controls.pathWidth": "దారి వెడల్పు",
  "tab.controls.pathWidthHint": "సున్నా దారులను దాస్తుంది",
  "tab.controls.colors": "రంగులు",
  "tab.controls.colorsHint": "రంగుల పాలెట్ తిప్పు",
  "tab.controls.shadows": "నీడలు",
  "tab.profile.loginTitle": "లాగిన్",
  "tab.profile.anonNote": "మీ సొంత కార్యకలాపాలను చూడటానికి, మీ Heatflask ఖాతాను నిర్వహించడానికి Strava తో లాగిన్ అవ్వండి.",
  "tab.profile.loginLink": "Strava తో లాగిన్ అవ్వండి",
  "tab.profile.editOnStrava": "Strava లో మీ ప్రొఫైల్ సవరించండి",
  "tab.profile.indexNote": "వేగంగా అందుబాటులో ఉండేందుకు మీ కార్యకలాపాల సారాంశాలను సూచికలో ఉంచుతాము.",
  "tab.profile.viewIndex": "సూచిక చూడండి",
  "tab.profile.sharedMaps": "పంచుకున్న మ్యాప్‌లు",
  "tab.profile.sharedMapsNote": "ఆఫ్: Heatflask లో మీ కార్యకలాపాలను మీరు మాత్రమే చూడగలరు. ఆన్: మీ మ్యాప్ లింక్ ఉన్న ఎవరైనా మీరు Strava లో పబ్లిక్ చేసిన కార్యకలాపాలను చూడగలరు. మీ ప్రైవేట్ కార్యకలాపాలు ఏ సందర్భంలోనైనా మీవిగానే ఉంటాయి. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">గోప్యత ఎలా పనిచేస్తుంది</a>",
  "tab.profile.logout": "లాగ్ అవుట్",
  "tab.profile.deleteAccount": "ఖాతాను తొలగించు",
  "tab.profile.deleteConfirm": "మీ Heatflask ఖాతాను తొలగించాలా?\n\nఇది మీ సూచికలోని కార్యకలాపాలను తీసివేసి, మీ Strava డేటాకు Heatflask ప్రాప్యతను రద్దు చేస్తుంది. దీన్ని వెనక్కి తీసుకోలేరు.",
  "tab.profile.languageHeading": "భాష",
  "tab.profile.languageAuto": "ఆటోమేటిక్",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">అనువాదాలను సరిచేయడంలో లేదా కొత్తవి చేర్చడంలో మాకు సహాయం చేయండి!</a>",
  "tab.profile.unitsHeading": "యూనిట్లు",
  "tab.profile.unitsAuto": "ఆటోమేటిక్",
  "tab.profile.unitsMetric": "మెట్రిక్ (కి.మీ, మీ)",
  "tab.profile.unitsImperial": "ఇంపీరియల్ (మైలు, అడుగు)",
  "tab.profile.textSizeHeading": "అక్షర పరిమాణం",
  "tab.profile.textSmaller": "చిన్నది",
  "tab.profile.textReset": "సాధారణం",
  "tab.profile.textLarger": "పెద్దది",
  "tab.profile.mapDefaultsHeading": "మ్యాప్ డిఫాల్ట్‌లు",
  "tab.profile.mapDefaultsNote": "లింక్ తన సొంత సెట్టింగ్‌లను నిర్ణయించని మ్యాప్‌ను తెరిచిన ప్రతిసారీ ఈ బేస్‌మ్యాప్, భూభాగం, లేయర్ సెట్టింగ్‌లతో ప్రారంభించు. మీరు పంచుకునే లింక్‌లు మాత్రం మీరు చూసేదాన్నే సరిగ్గా చూపిస్తాయి.",
  "tab.profile.mapDefaultsSave": "నా డిఫాల్ట్‌లుగా సేవ్ చేయి",
  "tab.profile.mapDefaultsForget": "మరచిపో",
  "tab.info.title": "సమాచారం",
  "tab.info.controlsHeading": "నియంత్రణలు",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + లాగు",
  "tab.info.shiftDragDesc": "ఒక పెట్టెలో కార్యకలాపాలను ఎంచుకోండి. టచ్‌స్క్రీన్‌లో ముందుగా <i class=\"hf-object-group\"></i> నొక్కి, ఆపై ఒక వేలితో లాగండి. చివరగా ఎంచుకున్న కార్యకలాపం వివరాలు చూపుతుంది, కార్యకలాపాల జాబితా దాని వరకు స్క్రోల్ అవుతుంది.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + లాగు",
  "tab.info.ctrlDragDesc": "మ్యాప్‌ను 3D లో తిప్పండి, వంచండి, లేదా రెండు వేళ్లను ఉపయోగించండి",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "సైడ్‌బార్ తెరువు లేదా మూసివేయి",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "మునుపటి లేదా తదుపరి సైడ్‌బార్ ట్యాబ్",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "సైడ్‌బార్ మూసివేయి",
  "tab.info.liveUrlHeading": "లైవ్ URL",
  "tab.info.liveUrlDesc": "మ్యాప్ వీక్షణ, యానిమేషన్ సెట్టింగ్‌లు పేజీ URL లో ఉంటాయి, కాబట్టి మీరు ఎవరితో పంచుకున్నా వారు అదే వీక్షణను చూస్తారు.",
  "tab.info.videoHeading": "వీడియో ఎగుమతి",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> బటన్ యానిమేషన్‌ను MP4 గా రికార్డ్ చేస్తుంది: దాన్ని నొక్కి, మ్యాప్‌లో మీకు కావలసిన భాగంపై పెట్టెను సరిచేసి, రికార్డ్ చేయడానికి మళ్లీ నొక్కండి. యానిమేషన్ యొక్క ఒక పూర్తి చక్రం రికార్డ్ అవుతుంది, కాబట్టి వీడియో అంతరాయం లేకుండా పునరావృతమవుతుంది; {max} సెకన్ల (Strava అంగీకరించే అతి పొడవైన వీడియో) కంటే పొడవైన చక్రం {max} వద్ద కత్తిరించబడుతుంది.",
  "tab.info.contributeHeading": "సహకరించండి",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub లో స్పాన్సర్ చేయండి",
  "tab.info.contactsHeading": "సంప్రదింపులు",
  "map.basemapAndTerrain": "బేస్‌మ్యాప్ మరియు భూభాగం",
  "map.pauseAnimation": "యానిమేషన్ ఆపు",
  "map.resumeAnimation": "యానిమేషన్ కొనసాగించు",
  "capture.record": "వీడియో రికార్డ్ ({period} సె. చక్రం)",
  "capture.recordTruncated": "వీడియో రికార్డ్ (ఒక చక్రం {period} సె.; మొదటి {max} సె. మాత్రమే రికార్డ్ అవుతాయి)",
  "capture.recordArea": "పెట్టెలోని ప్రాంతాన్ని రికార్డ్ చేయి",
  "capture.stop": "రికార్డింగ్ ఆపు",
  "capture.selectionTooSmall": "ఎంపిక చాలా చిన్నది",
  "capture.saved": "{name} సేవ్ అయింది ({size})",
  "capture.cancelled": "రికార్డింగ్ రద్దయింది",
  "capture.failed": "రికార్డింగ్ విఫలమైంది: {error}",
  "capture.loadingEncoder": "ఎన్‌కోడర్ లోడ్ అవుతోంది…",
  "capture.waitingForMap": "మ్యాప్ లోడ్ కోసం వేచి ఉంది…",
  "capture.encoding": "ఎన్‌కోడ్ అవుతోంది… {percent}%",
  "capture.finalizing": "పూర్తి చేస్తోంది…",
  "share.title": "ఈ మ్యాప్ లింక్‌ను పంచుకోండి",
  "share.copied": "లింక్ కాపీ అయింది",
  "share.copiedUnshared": "లింక్ కాపీ అయింది — కానీ మీ మ్యాప్ పంచుకోబడలేదు, కాబట్టి ఇతరులు దాన్ని తెరవలేరు. మార్చడానికి “పంచుకున్న మ్యాప్‌లు” ఆన్ చేయండి.",
  "share.unshared": "మీ మ్యాప్ పంచుకోబడలేదు, కాబట్టి ఇతరులు ఈ లింక్‌ను తెరవలేరు. మార్చడానికి “పంచుకున్న మ్యాప్‌లు” ఆన్ చేయండి.",
  "share.copyThis": "ఈ లింక్‌ను కాపీ చేయండి:",
  "update.available": "Heatflask కొత్త వెర్షన్ అందుబాటులో ఉంది.",
  "update.reload": "మళ్లీ లోడ్ చేయి",
  "import.title": "దిగుమతి అవుతోంది",
  "import.stop": "ఆపు",
  "import.stopping": "ఆగుతోంది…",
  "import.contacting": "Strava ను సంప్రదిస్తోంది…",
  "import.countOf": "కార్యకలాపాలు: {total} లో {received}",
  "import.count": "కార్యకలాపాలు: {received}",
  "import.waitStrava": "Strava డౌన్‌లోడ్ పరిమితి వల్ల {time} వరకు ఆగింది. ఈ పేజీని తెరిచే ఉంచండి; మళ్లీ లోడ్ చేస్తే వేగం పెరగదు.",
  "import.waitRationed": "ఈ రోజు వేగవంతమైన డౌన్‌లోడ్‌లు అయిపోయాయి. మిగతావి {time}కి నెమ్మదిగా కొనసాగుతాయి. ఈ పేజీని తెరిచే ఉంచండి.",
  "import.dailyLimit": "Strava రోజువారీ డౌన్‌లోడ్ పరిమితి అయిపోయింది. {time} తర్వాత మళ్లీ ప్రయత్నించండి.",
  "import.dailyRationed": "ఈ రోజుకు మీ Strava డౌన్‌లోడ్ వాటా అయిపోయింది. {time} తర్వాత మళ్లీ ప్రయత్నించండి.",
  "import.noActivitiesYet": "మీ Strava ఖాతాలో ఇంకా ఎలాంటి యాక్టివిటీలు లేవు. Strava లో ఒకదాన్ని రికార్డ్ చేయండి లేదా అప్‌లోడ్ చేయండి, అది ఇక్కడ కనిపిస్తుంది.",
  "table.noActivities": "కార్యకలాపాలు లేవు",
  "table.untitled": "(శీర్షిక లేదు)",
  "activities.pageTitle": "{app} — కార్యకలాపాల సూచిక",
  "activities.heading": "కార్యకలాపాల సూచిక",
  "activities.fetching": "కార్యకలాపాలను తెస్తోంది...",
  "activities.rateLimit": "Strava అభ్యర్థనల పరిమితి చేరింది; {time} కి మళ్లీ మొదలవుతుంది",
  "activities.noData": "క్షమించండి, డేటా లేదు &#128577;",
  "activities.colServerCache": "ట్రాక్ సర్వర్‌లో సేవ్ అయింది (Mongo)",
  "activities.colBrowserCache": "ట్రాక్ ఈ బ్రౌజర్‌లో సేవ్ అయింది",
  "activities.cachedServer": "{id} ట్రాక్ సర్వర్‌లో సేవ్ అయి ఉంది",
  "activities.notCachedServer": "{id} ట్రాక్ సర్వర్‌లో సేవ్ కాలేదు",
  "activities.cachedBrowser": "{id} ట్రాక్ ఈ బ్రౌజర్‌లో సేవ్ అయి ఉంది",
  "activities.notCachedBrowser": "{id} ట్రాక్ ఈ బ్రౌజర్‌లో సేవ్ కాలేదు",
  "sport.AlpineSki": "ఆల్పైన్ స్కీయింగ్",
  "sport.BackcountrySki": "బ్యాక్‌కంట్రీ స్కీయింగ్",
  "sport.Badminton": "బ్యాడ్మింటన్",
  "sport.Basketball": "బాస్కెట్‌బాల్",
  "sport.Canoeing": "కనూయింగ్",
  "sport.Cricket": "క్రికెట్",
  "sport.Crossfit": "క్రాస్‌ఫిట్",
  "sport.Dance": "నృత్యం",
  "sport.EBikeRide": "ఇ-బైక్ రైడ్",
  "sport.Elliptical": "ఎలిప్టికల్",
  "sport.EMountainBikeRide": "ఇ-మౌంటెన్ బైక్ రైడ్",
  "sport.Golf": "గోల్ఫ్",
  "sport.GravelRide": "గ్రావెల్ రైడ్",
  "sport.Handcycle": "హ్యాండ్‌సైకిల్",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "హైకింగ్",
  "sport.IceSkate": "ఐస్ స్కేటింగ్",
  "sport.InlineSkate": "ఇన్‌లైన్ స్కేటింగ్",
  "sport.Kayaking": "కయాకింగ్",
  "sport.Kitesurf": "కైట్‌సర్ఫింగ్",
  "sport.MountainBikeRide": "మౌంటెన్ బైక్ రైడ్",
  "sport.NordicSki": "నార్డిక్ స్కీయింగ్",
  "sport.Padel": "ప్యాడెల్",
  "sport.PhysicalTherapy": "ఫిజియోథెరపీ",
  "sport.Pickleball": "పికిల్‌బాల్",
  "sport.Pilates": "పిలేట్స్",
  "sport.Racquetball": "రాకెట్‌బాల్",
  "sport.Ride": "సైకిల్ రైడ్",
  "sport.RockClimbing": "రాక్ క్లైంబింగ్",
  "sport.RollerSki": "రోలర్ స్కీ",
  "sport.Rowing": "రోయింగ్",
  "sport.Run": "పరుగు",
  "sport.Sail": "తెరచాప పడవ",
  "sport.Skateboard": "స్కేట్‌బోర్డ్",
  "sport.Snowboard": "స్నోబోర్డ్",
  "sport.Snowshoe": "స్నోషూ",
  "sport.Soccer": "ఫుట్‌బాల్",
  "sport.Squash": "స్క్వాష్",
  "sport.StairStepper": "స్టెయిర్ స్టెప్పర్",
  "sport.StandUpPaddling": "స్టాండ్ అప్ ప్యాడ్లింగ్",
  "sport.Surfing": "సర్ఫింగ్",
  "sport.Swim": "ఈత",
  "sport.TableTennis": "టేబుల్ టెన్నిస్",
  "sport.Tennis": "టెన్నిస్",
  "sport.TrailRun": "ట్రైల్ రన్",
  "sport.Velomobile": "వెలోమొబైల్",
  "sport.VirtualRide": "వర్చువల్ రైడ్",
  "sport.VirtualRow": "వర్చువల్ రోయింగ్",
  "sport.VirtualRun": "వర్చువల్ పరుగు",
  "sport.Volleyball": "వాలీబాల్",
  "sport.Walk": "నడక",
  "sport.WeightTraining": "బరువుల శిక్షణ",
  "sport.Wheelchair": "చక్రాల కుర్చీ",
  "sport.Windsurf": "విండ్‌సర్ఫింగ్",
  "sport.Workout": "వ్యాయామం",
  "sport.Yoga": "యోగా"
}
